import { ReactNode, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { CustomTooltip } from '@components/CustomTooltip'
import { ProfileType } from '@modules/search/types'
import { Box } from '@mui/material'

import useHasContactedMap from '../hooks/useHasContactedMap'
import { ContactedBubbleIcon, ContactedBubbleWrapper } from './index.styles'

const ContactedBubble = (props: { children: ReactNode; hasContacted?: boolean }) => {
  const { t } = useTranslation()

  const { hasContacted, children } = props

  return (
    <ContactedBubbleWrapper>
      <Box display="inline-block">{children}</Box>

      {hasContacted && (
        <CustomTooltip title={t(translationKeys.EXISTING_CONVERSATION)} placement="top" arrow={false} padding="5">
          <ContactedBubbleIcon />
        </CustomTooltip>
      )}
    </ContactedBubbleWrapper>
  )
}

export const ContactedBubbleApiFull = (props: {
  children: ReactNode
  profileId: number
  profileType: ProfileType
  companyId: number
}) => {
  const { profileId, profileType, companyId, children } = props
  const displayType = profileType === ProfileType.delegate ? ProfileType.delegate : ProfileType.company

  const profileIds = useMemo(() => {
    const result = []
    if (companyId) {
      result.push({ type: ProfileType.company, id: companyId })
    }

    if (displayType === ProfileType.delegate && profileId) {
      result.push({ type: ProfileType.delegate, id: profileId })
    }

    return result
  }, [companyId, profileId, displayType])

  const contactedMap = useHasContactedMap({ profileIds })

  return <ContactedBubble hasContacted={!!contactedMap?.[displayType]?.[profileId]}>{children}</ContactedBubble>
}

export default ContactedBubble
